<template>
    <div v-if="!totalError" class="w-full"> 
        <!--AMOUNT SEND-->
        <span class="text-600">{{ lang('amount_send') }}: </span>
        <div v-if="currencyGetList && loaded" class="w-full mt-2 mb-3">
            <InputAmount :amount="amountGet" :currency="currencyGet" :currencies="currencyGetList" :min="minGetLimit" :max="maxGetLimit" 
                @update:amount="val => amountGet = val" @update:currency="val => currencyGet = val"
                :disableInput="false" :disableSelect="false" digits="2" :isClearButtons="false" :isRequest="false"/>
        </div>
        <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--AMOUNT RECEIVE-->
        <span class="text-600">{{ lang('amount_receive') }}:</span>
        <div class="w-full mt-2 mb-3" v-if="currencyGetList && loaded">
            <InputAmount :amount="amountReceive" :currency="currencyReceive" :currencies="currencyReceiveList" :min="null" :max="null" 
                @update:amount="val => amountReceive = val"  @update:currency="val => currencyReceive = val"
                :disableInput="true" :disableSelect="true" digits="2" :isClearButtons="false" :isRequest="false" currencyTitleKey="currency_receive"/>
        </div>
        <Skeleton v-if="!loaded || !currencyReceive" height="3rem" class="mt-2 mb-3 border-round-xl"/>

        <!--SENDER NAME-->
        <div v-if="user_name" class="flex flex-row mb-3">
            <span class="flex text-500">{{ lang('sender_name') }}: &nbsp</span>
            <span class="flex text-500 cursor-pointer" @click="go_profile()"> 
                {{ user_name }} &nbsp
            </span>
            <span class="pi pi-pencil text-500 cursor-pointer" @click="go_profile()"></span>
        </div>

        <!--GET PAY SYSTEM-->
        <span class="text-600">{{ lang('payment_method') }}:</span>
        <PaymentSysDropdown v-if="loaded && getPaySys" :pay_sys="getPaySys" :currency="currencyGet" type="get" :list="getPaySysListGrouped"
            @update:pay-sys="val => chooseGetPaySys(val)" :headerText="lang('choose_senders_bank')"/>
        <Skeleton v-else height="3rem" class="mt-2 mb-3 border-round-xl"/>
    </div>

    <!--ERRORS-->
    <div v-if="totalError" class="w-full max-w-30rem">
        <InlineMessage severity="warn" class="border-round-xl">
            {{ (totalErrorMessage == 'Error getting all merchs') ? lang('critical_error') : totalErrorMessage }}
        </InlineMessage>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import BigNumber from 'bignumber.js'
import Helper from '@/assets/js/Helper'
import { reactive, ref } from 'vue'
import FbConversion from '@/assets/js/classes/FbConversion.js'
import TransferCalculation from '@/assets/js/classes/TransferCalculation.js'
import InputAmount from '@/components/widgets/transfer/InputAmount.vue'
import PaymentSysDropdown from '@/components/widgets/transfer/PaymentSysDropdown.vue'
import { PaymentSystemList, BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList} from '@/assets/js/classes/Currency.js'
import { RateList } from '@/assets/js/classes/Rate.js'

export default {
	name: 'TopUpTransfer',
    props: {
        wallet_id: {
            type: Number,
            default: null
        },
        wallet_currency: {
            type: String,
            default: null
        },
        onClick: {
            type: Boolean,
            default: false
        },
    },
	data() {
		return {
            loaded: false,
            isLoading: false,
            recalculating: false,
            totalError: false,
            totalErrorMessage: '',

            arrCurrencies: [],
            arrPaymetSystems: [],
            arrRates: [],
            arrBanks: [],

			amountGet: null,
            amountReceive: null,
            minGetLimit: null,
			maxGetLimit: null,

            // Валюты
            currencyGet: null,
            currencyGetList: [],
            currencyReceive: null,
            currencyReceiveList: [],

            // Платежные системы            
            getPaySys: null,
            getPaySysList: [],
            getPaySysListGrouped: [],
            receivePaySys: null,
            receivePaySysList: [],

            description: null,
            hide_desc: true,

            CALC: null,
		}
	},
    components: {
        InputAmount,
        PaymentSysDropdown,
    },
    setup () {
        const react = reactive({
            recalculating_: false,
        })
        return { react }
    },
	watch: {
        amountGet: function () {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('amount_get').then(() => {
                    this.recalculating = false
                })
            }
		},
        amountReceive: function () {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('amount_receive').then(() => {
                    this.recalculating = false
                })
            }
		},
		currencyGet: function (that) {
            if(this.loaded && !this.recalculating){
                this.recalculating = true
			    this.Recalculate('currency_get').then(() => {
                    this.recalculating = false
                })
            }
		},
        currencyReceive: function (that) {
            if(this.loaded && !this.recalculating){
			    this.Recalculate('currency_receive').then(() => {
                    this.recalculating = false
                })
            }
		},
        onClick: function () {
            this.Create()
        },
        isLoading: function(that){
            this.$emit('loading', that)
        },
	},
	methods: {
        getBankCodeFromPaySys(obj){
            if(!obj || !obj.bank || !obj.bank.code) return null
            return obj.bank.code
        },
        getRateFromArray(rates_array, from_currency_code, to_currency_code){
            if(!rates_array || !rates_array.length) return null
            for(let i = 0; i < rates_array.length; i++){
                if(rates_array[i].from_currency_code == from_currency_code && rates_array[i].to_currency_code == to_currency_code) 
                    return rates_array[i]
            }
            return null
        },
        // Получение массива валют отправки
        getSendCurrencies(filteredRates){
            if(!filteredRates) return []
            if(!Array.isArray(filteredRates) || !filteredRates.length) return []
            if(!this.arrCurrencies || Object.keys(this.arrCurrencies).length === 0) return []
            let currencies_obj = {}
            for (const [k, v] of Object.entries(this.arrCurrencies)) {
                for(let i = 0; i < filteredRates.length; i++) {
                    if(filteredRates[i].from_currency_code == v.code) currencies_obj[v.code] = v
                }
            }
            const values = Object.values(currencies_obj)
            values.sort((a, b) => {
                const valA = a.sort !== undefined ? a.sort : 9999
                const valB = b.sort !== undefined ? b.sort : 9999
                return valA - valB
            })
            return values
        },
        get_code(obj){
            if(!obj || obj.code == undefined) return ''
            return obj.code
        },
        lang(value) { return this.$t(`views.transfer.${value}`)},
        rateHasSendBankCode(rate, bankCode){
            if(!rate || !rate.pays_send_codes || rate.pays_send_codes.length<=0) return false
            for(let i = 0; i < rate.pays_send_codes.length; i++){
                if(rate.pays_send_codes[i] == bankCode) return true
            }
            return false
        },
        chooseGetPaySys(item){
            if(this.loaded && !this.isRecalculating){
                this.getPaySys = this.setGetPaySys(item)
                this.Recalculate('get_pay_sys', this.filterPaySys).then(res => {
                    this.isRecalculating = false
                })
            }
        },
		setGetPaySys(item) {
            if(!this.getPaySysList) return null
            const isPayCode = (item && item.pay_sys && item.pay_sys.code) ? item.pay_sys.code : null
            const isBankCode = (item && item.bank && item.bank.code) ? item.bank.code : null
			for (const [k, v] of Object.entries(this.getPaySysList)) {
				if (isBankCode) { if (v.bank && v.bank.code == isBankCode) return v } 
                else { if (v.pay_sys && v.pay_sys.code == isPayCode) return v }
			}
			return null
		},
		async Recalculate(from = null) {

            // console.log('FROM: ', from)

            if(from=='start'){
                // определяем валюту для получения (по коду USDT)
                
                this.currencyReceive = this.arrCurrencies['usdt']
                this.currencyReceiveList = [this.currencyReceive]

                // определяем валюты доступные для отправки
                const filteredRates = this.arrRates.filter(r => r.to_currency_code == this.currencyReceive.code)
                this.currencyGetList = this.getSendCurrencies(filteredRates)

                if(this.currencyGetList.length <= 0) {
                    this.totalError = true
                    this.totalErrorMessage = this.lang('err_no_currency_get')
                    return
                }
            }

            // если валюта отправки не определена - берем первую
            if(from=='start' && (!this.currencyGet || !this.currencyGet.code)){
                this.currencyGet = this.currencyGetList[0]
            } 

            // если валюта отправки не определена
            if(!this.currencyGet || !this.currencyGet.code) {
                this.totalError = true
                this.totalErrorMessage = this.lang('err_no_currency_get')
                return
            }

            // Определяем объект расчета
            const CALC = new TransferCalculation({})
            CALC.from_currency_code = this.currencyGet.code
            CALC.to_currency_code = this.currencyReceive.code

            // Ищем текущий курс
            const rate = this.getRateFromArray(this.arrRates, this.currencyGet.code, this.currencyReceive.code)
            if(!rate) {
                this.totalError = true
                this.totalErrorMessage = 'No rate found' // TODO: добавить сообщение об ошибке
                return
            }
            // console.log('RATE FOUND: ', rate)

            // Задаем курс
            CALC.setRate(rate, 'topup')
            
            // ищем - есть ли в банках выплаты наш код банка
            if(!this.rateHasSendBankCode(rate, 'internal_topup')) {
                this.totalError = true
                this.totalErrorMessage = this.lang('err_no_bank')
                return false
            }

            // определяем платежки и устанавливаем лимиты
            if(from=='start' || from=='currency_get'){
                // определяем платежные системы (обновляем если перевыбрана валюта отправки)
                this.getPaySysList = await PaymentSystemList.RecognizePays(rate, 'get', this.$store).then(r=>r)
                this.getPaySys = (this.getPaySysList[0]) ? this.getPaySysList[0] : null
                this.getPaySysListGrouped = PaymentSystemList.GroupByType(this.getPaySysList)
                this.receivePaySysList = await PaymentSystemList.RecognizePays(rate, 'send', this.$store).then(r=>r)
                this.receivePaySys = this.getInternalPaySys(this.receivePaySysList)

                if(!this.getPaySys || !this.receivePaySys) {
                    this.totalError = true
                    this.totalErrorMessage = this.lang('err_payment_system')
                    return
                }
            }

            // Задаем платежные системы            
            CALC.setGetPaySys(this.getPaySys.pay_sys)
            CALC.setSendPaySys(this.receivePaySys.pay_sys)

            // Банки
            CALC.setGetBank(this.getPaySys.bank)
            CALC.setSendBank(this.receivePaySys.bank)

            // Корректировка мерчантов в зависимости от типа платежной системы
            if(this.getPaySys.pay_sys.type!='merchant') CALC.merchants.get.percent = 0
            if(this.receivePaySys.pay_sys.type!='merchant') CALC.merchants.send.percent = 0

            this.minGetLimit = CALC.getMinGetLimit()
            this.maxGetLimit = CALC.getMaxGetLimit()

            // console.log('MIN GET: ', this.minGetLimit)
            // console.log('MAX GET: ', this.maxGetLimit)

            if(from=='start' || from=='currency_get'){
                this.amountGet = this.minGetLimit
            }

            // Проверка суммы ПРИЕМА по лимитам
            const bAmountGet = new BigNumber(this.amountGet)
            const bMinGetLimit = new BigNumber(this.minGetLimit)
            const bMaxGetLimit = new BigNumber(this.maxGetLimit)
            if(bAmountGet.isLessThan(bMinGetLimit)) this.amountGet = this.minGetLimit
            if(bAmountGet.isGreaterThan(bMaxGetLimit)) this.amountGet = this.maxGetLimit

            const bAmountSend = new BigNumber(this.amountReceive)
            if(bAmountSend.isLessThan(bMinGetLimit)) this.amountReceive = this.minGetLimit
            if(bAmountSend.isGreaterThan(bMaxGetLimit)) this.amountReceive = this.maxGetLimit
            
            // задаем сумму для расчета
            CALC.sender.amount = new BigNumber(this.amountGet)
            CALC.recipient.amount_usdt = CALC.calcRecipientAmountUsdt() 
            CALC.recipient.amount = CALC.calcRecipientAmount() 
            this.amountReceive = CALC.recipient.amount.toFixed(16)

            // console.log("CALC", CALC.toObject())

            CALC.calcResultRate()
            this.CALC = CALC    

            return
		},
        getInternalPaySys(array){
            if(!array || array.length <= 0) return null
            for(let i = 0; i < array.length; i++){
                if(array[i].pay_sys && array[i].pay_sys.type && array[i].pay_sys.type == 'internal') return array[i]
            }
            return null
        },
		showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        go_profile(){
            this.$router.push({path: '/personal/profile/'})
        },
        //создание перевода
        async Create(){
            this.isLoading = true 
            let transfer = {}

            console.log("CALC", this.CALC.toObject())

            try {

                let fbp, fbc, url
                try{
                    fbp = this.helper.getFbp()
                    fbc = this.helper.getFbc()
                    url = this.helper.getUrl()
                } catch(e) {
                    console.log('error', e)
                }

                const data = {
                    wallet_id:              this.wallet_id,
                    currency_code:          this.get_code(this.currencyGet),
                    wallet_currency_code:   this.wallet_currency,
                    amount_send:            this.CALC.sender.amount.toFixed(16),
                    amount_receive:         this.CALC.recipient.amount.toFixed(16),
                    payment_system_code:    this.getPaySys.pay_sys.code,
                    payment_system_type:    this.getPaySys.pay_sys.type,
                    bank_code:              this.getBankCodeFromPaySys(this.getPaySys),
                    rate:                   this.CALC.rate.value.toString(),
                    description:            this.description,
                    source:                 (this.isTgApp) ? 'tgapp' : 'web',
                    browser: {
                        fbp: fbp,
                        fbc: fbc,
                        url: url
                    }
                }

                transfer = await this.connect.TopupWalletByTransfer(data).then(res=>res)
                if(transfer.result && transfer.data) {
                    //успешно создали трансфер
                    this.showMess('success', this.lang('success_title'), this.lang('success_subtitle'))

                    // отправляем событие об успешном создании перевода
                    try {
                        const trId = (transfer.data && transfer.data._id) ? transfer.data._id : null
                        const trSenderId = (transfer.data && transfer.data.sender && transfer.data.sender.user_id) ? transfer.data.sender.user_id : null
                        const eventId = (trId) ? 'transfer-' + trId : null
                        const date = (transfer.data && transfer.data.dates && transfer.data.dates.created) ? transfer.data.dates.created : null
                        const timestamp = Math.floor(date / 1000)
                        const userAgent = this.helper.getUserAgent()

                        let fbConv = new FbConversion('transferCreate')
                        if(eventId)     fbConv.setId(eventId)
                        if(trSenderId)  fbConv.setExternalId(trSenderId)
                        if(timestamp)   fbConv.setTime(timestamp)
                        if(userAgent)   fbConv.setUserAgent(userAgent)
                        if(url)         fbConv.setUrl(url)
                        if(fbp)         fbConv.setFbp(fbp)
                        if(fbc)         fbConv.setFbc(fbc)
                        const eventData = fbConv.get()

                        this.event.send('transferCreate', eventData) 
                    } catch (e) {
                        console.log('error send event', e)
                    }

                    this.$router.push({path: '/personal/transfer/'+transfer.data._id})
                } else {
                    if(transfer.error && this.getErrorMessage(transfer.error)) {
                        this.showMess('warn', this.lang('error_title'), this.getErrorMessage(transfer.error)) 
                    } else {
                        if(transfer.message) this.showMess('error', this.lang('error_title'), transfer.message)
                        else this.showMess('error', this.lang('error_title'), 'Unknown error')
                    }
                }
                this.isLoading = false
            } catch(e) {
                console.log('error', e)
                const msg = (e.message) ? e.message : 'Error'
                this.showMess('error', 'Error', msg)
                this.isLoading = false
            }

            return
        },
        getErrorMessage(code){
            let message = null
            switch(code){
                case 'test_return':
                    message = this.lang('err_test_return')
                    break
                case 'verification_required':
                    message = this.lang('err_verification_required')
                    break
                case 'existing_open_transfers':
                    message = this.lang('err_existing_open_transfers')
                    break
                case 'amounts_not_equal':
                case 'comissions_not_equal':
                    message = this.lang('err_amounts_not_equal')
                    this.refresh()      // обновляем курсы
                    break
                case 'rates_not_equal':
                    message = this.lang('err_rates_not_equal')
                    this.refresh()      // обновляем курсы
                    break
                case "free_transfer_not_available":
                    message = this.lang('err_free_transfer_not_available')
                    this.LoadStatOfUser().then(() => {
                        this.refresh()      // обновляем курсы
                    })
                    break
                default:
                    message = null
            }
            return message
        }
	},
    computed : {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        user_name: function () { return this.$store.getters.StateUserName },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
	beforeCreate() {
        this.connect = new Connect()
        this.event = new Event(this)
        this.helper = new Helper()
    },
	async mounted() {
        
        // платежные системы | обязательно
        this.arrPaymetSystems = await PaymentSystemList.GetList(this.$store).then(r=>r)
        if (!this.arrPaymetSystems || this.arrPaymetSystems.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No payment systems loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrPaymetSystems', this.arrPaymetSystems)

        // валюты | обязательно
        const resCurrencies = await CurrencyList.GetList(this.$store).then(r=>r)
        if (!resCurrencies || resCurrencies.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No currencies loaded' // TODO: вывести ошибку на разных языках
            return
        }
        this.arrCurrencies = CurrencyList.ToObjectMap(resCurrencies)
        // console.log('arrCurrencies', this.arrCurrencies)

        // банки | обязательно
        this.arrBanks = await BankList.GetList(this.$store).then(r=>r)
        if (!this.arrBanks || this.arrBanks.length <= 0){
            this.totalError = true
            this.totalErrorMessage = 'No banks loaded' // TODO: вывести ошибку на разных языках
            return
        }
        // console.log('arrBanks', this.arrBanks)

        // Курсы доступных валют | обязательно
        const resRates = await this.connect.GetRatesByType('topup').then(res => res)
        if (!resRates.result || !resRates.data || resRates.data.length <= 0){
            this.totalError = true
            if(resRates.errors && resRates.errors.length > 0) this.totalErrorMessage = resRates.errors[0]
            else this.totalErrorMessage = 'No rates loaded'
            return
        }
        // проверяем на обязательные поля
        const objRates = new RateList(resRates.data)
        this.arrRates = objRates.toArrayObj()
        // console.log('rates', this.arrRates)

        this.loaded = true
        this.react.recalculating_ = true
        this.recalculating = true

        this.Recalculate('start').then(res => {
            this.react.recalculating_ = false
            this.recalculating = false
        })
	}
}
</script>